import createReactClass from "create-react-class";
import React from "react";
import { Glyphicon, MenuItem, NavDropdown } from "react-bootstrap";
import { SchematicAPI } from "../actions/schematicAPI";
import { ServerActions } from "../actions/serverActions";
import { UserActions } from "../actions/userActions";
import Constants from "../constants/constants";
import { restrictionRequestStore } from "../stores/restrictionRequest";
import { userStore } from "../stores/user";

//function to get state from store, getting the currently loaded formb
function getStateFromStores() {
  return {
    userRole: userStore.getUserRole(),
    selectedRole: userStore.getSelectedRole(),
    printLataId: userStore.getLata(),
    isDirty: restrictionRequestStore.isDirty()
  };
}

var UserView = createReactClass({
  componentDidMount: function () {
    userStore.subscribe(this._onChange);
    restrictionRequestStore.subscribe(this._onChange);
    // UserActions.getActiveOverride({ userId: window.gritConfig.userId }); //Check if there is an active override on the server
  },

  componentWillUnmount: function () {
    userStore.unsubscribe(this._onChange);
    restrictionRequestStore.unsubscribe(this._onChange);
  },
  onToggle: function (isOpen, e, { source }) {
    if (
      source === "select" ||
      (source === "rootClose" &&
        ["userButton", "userButtonIcon"].includes(e.target.id))
    ) {
      return;
    }
    this.setState({ menuOpen: !!isOpen });
  },

  getInitialState: function () {
    const storeState = getStateFromStores();
    return {
      showHelp: false,
      menuOpen: false,
      ...storeState
    };
  },

  _onChange: function () {
    this.setState(getStateFromStores());
  },

  handleAdminClick: function () {
    ServerActions.openAdminPages();
  },

  /**
   * Calls to the server and opens the form a and form b web browse print windows
   */
  handleGuideClick: function () {
    window.open(
      "../PdfPrint/showFieldGuide",
      "fieldGuideWindow",
      "toolbar=no,width=1000,height=1000,left=100,top=20,status=no,scrollbars=yes,resize=no"
    );
  },

  handleDefaultTrackAdminClick: function () {
    ServerActions.openDefaultTrackAdminPage();
  },

  onUserSelectChange: function (event) {
    var val = event.target.value;
    if (this.state.isDirty) {
      window
        .confirm("Confirm Role Change", {
          confirmLabel: "Change to " + event.target.value,
          abortLabel: "Cancel",
          description:
            "Changing roles will reset all your work, including the territory and subdivision selection. Are you sure you want to do this?",
        })
        .then(function () {
          UserActions.selectChanged(val);
        });
    } else {
      UserActions.selectChanged(event.target.value);
    }
  },
  changeGisEnv: function (event) {
    var val = event.target.value;

    window.gritConfig.gisEnvironment = val;

    $("#mainSchematic").empty();
    SchematicAPI.initialize();
  },

  onLataChange: function (event) {
    this._forceOpen = true;
    UserActions.lataChanged(event.target.value);
    this.setState({ menuOpen: true });
  },

  close() {
    var st = getStateFromStores();
    st.showHelp = false;
    this.setState(st);
  },

  open() {
    var st = getStateFromStores();
    st.showHelp = true;
    this.setState(st);
  },

  //modify this to return the formBform view markup
  render: function () {
    var roles = [];
    var envs = [];
    var isReadOnly = false;
    if (this.state.selectedRole.indexOf(Constants.Roles.DISPATCHER) == 0) {
      $("body").addClass("dispatcherUser");
    } else {
      $("body").removeClass("dispatcherUser");
    }

    envs.push(
      <option key={"dev"} value={"dev"}>
        DEV
      </option>
    );
    envs.push(
      <option key={"trial"} value={"trial"}>
        TRIAL
      </option>
    );

    if (this.state.userRole.indexOf(Constants.Roles.READ_ONLY) > -1) {
      roles.push(
        <option
          key={Constants.Roles.READ_ONLY}
          value={Constants.Roles.READ_ONLY}
        >
          Read Only
        </option>
      );
      // isReadOnly = true;
    } else {
      if (this.state.userRole.indexOf(Constants.Roles.SUPER_USER) > -1) {
        roles.push(
          <option
            key={Constants.Roles.SUPER_USER}
            value={Constants.Roles.SUPER_USER}
          >
            Super User
          </option>
        );
      }

      if (this.state.userRole.indexOf(Constants.Roles.ADMIN) > -1) {
        roles.push(
          <option key={Constants.Roles.ADMIN} value={Constants.Roles.ADMIN}>
            Admin
          </option>
        );
      }

      if (this.state.userRole.indexOf(Constants.Roles.DISPATCHER) > -1) {
        roles.push(
          <option
            key={Constants.Roles.DISPATCHER}
            value={Constants.Roles.DISPATCHER}
          >
            Dispatcher
          </option>
        );
      }

      if (
        this.state.userRole.indexOf(Constants.Roles.FIELD_USER_B) > -1 ||
        this.state.userRole.indexOf(Constants.Roles.FIELD_USER_A) > -1 ||
        this.state.userRole.indexOf(Constants.Roles.FIELD_USER_C) > -1 ||
        this.state.userRole.indexOf(Constants.Roles.FIELD_SLODT) > -1
      ) {
        roles.push(
          <option
            key={Constants.Roles.FIELD_USER}
            value={Constants.Roles.FIELD_USER}
          >
            Field User
          </option>
        );
      }
    }

    var userTitle = (
      <div id="userButtonIcon">
        {this.props.user?.profile?.sub?.toUpperCase()} <Glyphicon glyph="user" />
      </div>
    );

    return (
      <NavDropdown
        noCaret
        id="userButton"
        open={this.state.menuOpen}
        onToggle={this.onToggle}
        title={userTitle}
      >
        <MenuItem eventKey="1">
          Role:
          <select
            id="userSelect"
            value={this.state.selectedRole[0]}
            disabled={isReadOnly}
            onChange={this.onUserSelectChange}
          >
            {roles}
          </select>
        </MenuItem>

        <MenuItem eventKey="2" onClick={this.menuItemOnClickDoNotCloseDropDown}>
          LATA:
          <input
            type="text"
            onChange={this.onLataChange}
            value={this.state.printLataId}
            id="printLataId"
            name="Print Lata ID"
            placeholder="Print Lata"
            maxLength="8"
          />
        </MenuItem>
      </NavDropdown>
    );
  },
});

export default UserView;
